import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import { getPublishedContent } from '../../services/contentService';
import Navbar from '../../components/navbar/Navbar';

// Container component (copied from HomePage)
const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

// Sample blog posts data
const sampleBlogPosts = [
  {
    id: 1,
    title: "The Ultimate Guide to Skincare Routines for Every Skin Type",
    slug: "ultimate-guide-skincare-routines",
    excerpt: "Discover the perfect skincare routine for your skin type with our comprehensive guide covering everything from cleansing to moisturizing.",
    image: "/images/hero-face.png",
    date: "2024-01-15",
    readTime: "8 min read",
    category: "Skincare",
    tags: ["skincare", "routine", "beauty"],
    author: "Dr. Sarah Chen",
    isNew: true,
    isPopular: false,
    isEvergreen: true
  },
  {
    id: 2,
    title: "Why Niacinamide Is Going Viral on TikTok (And What Actually Works)",
    slug: "niacinamide-tiktok-trend",
    excerpt: "The ingredient everyone's talking about: we break down the science behind niacinamide and why it's trending everywhere.",
    image: "/images/makeup-swatches.png",
    date: "2024-01-12",
    readTime: "5 min read",
    category: "Skincare",
    tags: ["niacinamide", "trending", "tiktok"],
    author: "Radiance Team",
    isNew: false,
    isPopular: true,
    isEvergreen: false
  },
  {
    id: 3,
    title: "Understanding Your Skin Type: A Complete Analysis Guide",
    slug: "understanding-skin-type",
    excerpt: "Learn how to identify your skin type and choose the right products for optimal skin health and appearance.",
    image: "/images/skincare-woman.png",
    date: "2024-01-05",
    readTime: "5 min read",
    category: "Skincare",
    tags: ["skincare", "skin-type", "beauty"],
    author: "Dr. Sarah Chen",
    isNew: true,
    isPopular: true,
    isEvergreen: true
  },
  {
    id: 4,
    title: "The Science Behind Anti-Aging: What Actually Works",
    slug: "science-behind-anti-aging",
    excerpt: "Explore the latest research and ingredients that help combat signs of aging and maintain youthful-looking skin.",
    image: "/images/woman-applying-facemask.png",
    date: "2024-01-01",
    readTime: "7 min read",
    category: "Skincare",
    tags: ["anti-aging", "science", "skincare"],
    author: "Dr. Sarah Chen",
    isNew: false,
    isPopular: true,
    isEvergreen: true
  },
  {
    id: 5,
    title: "Building a Sustainable Beauty Routine That Works",
    slug: "sustainable-beauty-routine",
    excerpt: "Learn how to create an eco-friendly beauty routine that's good for your skin and the planet.",
    image: "/images/glowing-face.png",
    date: "2023-12-28",
    readTime: "6 min read",
    category: "Wellness",
    tags: ["sustainability", "beauty", "wellness"],
    author: "Emma Rodriguez",
    isNew: false,
    isPopular: false,
    isEvergreen: true
  },
  {
    id: 6,
    title: "The Psychology of Beauty and Self-Care Practices",
    slug: "psychology-beauty-self-care",
    excerpt: "Understanding how beauty routines impact mental health and overall well-being.",
    image: "/images/lip-swatches.png",
    date: "2023-12-20",
    readTime: "9 min read",
    category: "Wellness",
    tags: ["psychology", "self-care", "beauty"],
    author: "Emma Rodriguez",
    isNew: false,
    isPopular: false,
    isEvergreen: true
  },
  {
    id: 7,
    title: "Clean Girl Makeup: The Look That's Everywhere Right Now",
    slug: "clean-girl-makeup-trend",
    excerpt: "From TikTok to red carpets, the 'clean girl' aesthetic is dominating beauty. Here's how to nail the look.",
    image: "/images/makeup-swatches.png",
    date: "2023-12-15",
    readTime: "4 min read",
    category: "Makeup",
    tags: ["makeup", "trends", "clean-girl"],
    author: "Radiance Team",
    isNew: true,
    isPopular: true,
    isEvergreen: false
  },
  {
    id: 8,
    title: "Hair Care Essentials: From Scalp to Tips",
    slug: "hair-care-essentials",
    excerpt: "Complete guide to maintaining healthy hair with the right products and techniques.",
    image: "/images/hero-face.png",
    date: "2023-12-10",
    readTime: "6 min read",
    category: "Hair",
    tags: ["hair", "care", "beauty"],
    author: "Dr. Sarah Chen",
    isNew: false,
    isPopular: true,
    isEvergreen: true
  },
  {
    id: 9,
    title: "The 5-Step Skincare Routine That Actually Works",
    slug: "5-step-skincare-routine",
    excerpt: "Skip the 10-step routines. This simple, effective 5-step process will transform your skin.",
    image: "/images/skincare-woman.png",
    date: "2023-12-05",
    readTime: "6 min read",
    category: "Skincare",
    tags: ["skincare", "routine", "simple"],
    author: "Dr. Sarah Chen",
    isNew: false,
    isPopular: false,
    isEvergreen: true
  },
  {
    id: 10,
    title: "Retinol for Beginners: Everything You Need to Know",
    slug: "retinol-beginners-guide",
    excerpt: "The anti-aging ingredient that actually works, explained in simple terms for skincare newbies.",
    image: "/images/woman-applying-facemask.png",
    date: "2023-11-28",
    readTime: "8 min read",
    category: "Skincare",
    tags: ["retinol", "anti-aging", "beginners"],
    author: "Dr. Sarah Chen",
    isNew: false,
    isPopular: false,
    isEvergreen: true
  },
  {
    id: 11,
    title: "Glass Skin: The Korean Beauty Trend That's Here to Stay",
    slug: "glass-skin-korean-beauty",
    excerpt: "Achieve that dewy, luminous complexion with these K-beauty inspired techniques and products.",
    image: "/images/glowing-face.png",
    date: "2023-11-20",
    readTime: "5 min read",
    category: "Skincare",
    tags: ["glass-skin", "korean-beauty", "trending"],
    author: "Emma Rodriguez",
    isNew: false,
    isPopular: true,
    isEvergreen: false
  },
  {
    id: 12,
    title: "Hair Oiling: The Ancient Practice That's Making a Comeback",
    slug: "hair-oiling-ancient-practice",
    excerpt: "From scalp to ends, discover the benefits of hair oiling and how to do it right.",
    image: "/images/hero-face.png",
    date: "2023-11-15",
    readTime: "7 min read",
    category: "Hair",
    tags: ["hair-oiling", "ancient-practices", "wellness"],
    author: "Emma Rodriguez",
    isNew: false,
    isPopular: false,
    isEvergreen: true
  }
];

const mainCategories = [
  'Skincare', 'Hair', 'Makeup', 'Wellness'
];

const contentSections = [
  { id: 'all', label: 'All Articles', filter: (posts) => posts },
  { id: 'guides', label: 'Guides', filter: (posts) => posts.filter(post => post.isEvergreen) }
];

function BlogIndexPage() {
  const [blogPosts, setBlogPosts] = useState(sampleBlogPosts);
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [email, setEmail] = useState('');
  const { categories } = useData();

  useEffect(() => {
    const fetchBlogPosts = async () => {
      setLoading(true);
      try {
        const response = await getPublishedContent('blog');
        if (response && response.data && response.data.length > 0) {
          // Transform API data to match expected structure
                          const transformedPosts = response.data.map((post, index) => {
                            console.log(`Processing post ${index}:`, post.title, 'Image:', post.image);
                            return {
                              id: post._id,
                              title: post.title,
                              slug: post.slug,
                              excerpt: post.description || 'No description available',
                              image: post.image || "/images/hero-face.png", // Use post image or default
                              date: post.publishedAt || post.createdAt,
                              readTime: post.readTime || "5 min read",
                              category: post.eyebrow || "Blog",
                              tags: post.tags || [],
                              author: "Radiance Team",
                              isNew: index < 3, // Mark first 3 as new
                              isPopular: index < 5, // Mark first 5 as popular
                              isEvergreen: true // All blog posts are evergreen for now
                            };
                          });
          setBlogPosts(transformedPosts);
        } else {
          // If no API data, keep sample data
          setBlogPosts(sampleBlogPosts);
        }
      } catch (error) {
        console.error('Error fetching blog posts:', error);
        // On error, keep sample data
        setBlogPosts(sampleBlogPosts);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  // Keyboard shortcut for search
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === '/' && !e.ctrlKey && !e.metaKey && e.target.tagName !== 'INPUT') {
        e.preventDefault();
        const searchInput = document.querySelector('input[placeholder*="Search articles"]');
        if (searchInput) {
          searchInput.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'long',
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Redirect to Mailchimp subscription form
    window.open('http://eepurl.com/jpTPXQ', '_blank', 'noopener,noreferrer');
    setEmail('');
  };

  const getFilteredPosts = () => {
    const sectionFilter = contentSections.find(section => section.id === activeSection);
    let filteredPosts = sectionFilter ? sectionFilter.filter(blogPosts) : blogPosts;
    
    if (selectedCategory !== 'All') {
      filteredPosts = filteredPosts.filter(post => post.category === selectedCategory);
    }
    
    if (searchQuery) {
      filteredPosts = filteredPosts.filter(post => 
        post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        post.excerpt.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    
    return filteredPosts;
  };

  const filteredPosts = getFilteredPosts();

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar (same as HomePage) */}
      <Navbar />
      
      {/* Cleaner Header */}
      <div className="bg-white pt-24 pb-8 md:pt-32 md:pb-12">
        <Container>
          <div className="max-w-4xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4" 
                style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700 }}>
              Your guide to what's <span className="text-[#ab3d22]">trending.</span>
            </h1>
            <p className="text-base md:text-lg text-gray-600">Real advice on beauty products worth your money.</p>
          </div>
        </Container>
      </div>

      {/* Simplified Navigation & Search */}
      <div className="bg-white border-b border-gray-200 sticky top-16 z-30">
        <Container>
          {/* Mobile: Stack vertically, Desktop: Side by side */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between py-4 gap-4">
            {/* Navigation Tabs */}
            <div className="flex items-center gap-2 flex-wrap">
              {contentSections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => setActiveSection(section.id)}
                  className={`px-4 py-2 text-sm font-medium whitespace-nowrap rounded-lg transition-all duration-200 ${
                    activeSection === section.id
                      ? 'bg-[#ab3d22] text-white'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  {section.label}
                </button>
              ))}
            </div>
            
            {/* Search Bar */}
            <div className="relative w-full md:w-auto">
              <input
                type="text"
                placeholder="Search articles..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full md:w-64 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ab3d22] focus:border-transparent transition-all"
                onKeyDown={(e) => {
                  if (e.key === 'Escape') {
                    setSearchQuery('');
                    e.target.blur();
                  }
                }}
              />
              <svg className="absolute right-2.5 top-2.5 h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Content */}
      <div className="bg-white py-12">
        <Container>

          {/* Blog Posts Layout */}
          {loading ? (
            <div className="text-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#ab3d22] mx-auto"></div>
              <p className="mt-4 text-gray-600">Loading blog posts...</p>
            </div>
           ) : (
             <>
               {/* Featured Section - Magazine Style */}
               {filteredPosts.length > 0 && activeSection === 'all' && (
                 <div className="mb-16">
                   <div className="grid lg:grid-cols-3 gap-8">
                     {/* Featured Post - Large */}
                     <div className="lg:col-span-2">
                       <article className="group cursor-pointer">
                         <Link to={`/blog/${filteredPosts[0].slug}`} className="block">
                           <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                             <div className="aspect-[16/10] bg-gray-100 overflow-hidden relative">
                               <img
                                 src={filteredPosts[0].image}
                                 alt={`${filteredPosts[0].category} guide: ${filteredPosts[0].title}`}
                                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                 onError={(e) => {
                                   e.target.src = "data:image/svg+xml,%3Csvg width='800' height='500' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f3f4f6'/%3E%3Ctext x='50%25' y='50%25' font-size='24' fill='%236b7280' text-anchor='middle' dy='.3em'%3ERadiance%3C/text%3E%3C/svg%3E";
                                 }}
                               />
                               <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                             </div>
                             <div className="p-8">
                               <div className="flex items-center gap-3 text-sm text-gray-500 mb-4">
                                 <span>{formatDate(filteredPosts[0].date)}</span>
                                 <span>•</span>
                                 <span>{filteredPosts[0].readTime}</span>
                                 <span>•</span>
                                 <span>{filteredPosts[0].author}</span>
                               </div>
                               <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight group-hover:text-[#ab3d22] transition-colors duration-300" 
                                   style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 700 }}>
                                 {filteredPosts[0].title}
                               </h2>
                               <p className="text-lg text-gray-600 leading-relaxed mb-6">
                                 {filteredPosts[0].excerpt}
                               </p>
                               <div className="flex items-center text-[#ab3d22] font-semibold group-hover:gap-2 transition-all duration-300">
                                 Read More
                                 <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                 </svg>
                               </div>
                             </div>
                           </div>
                         </Link>
                       </article>
                     </div>

                     {/* Sidebar - Text-only posts */}
                     <div className="lg:col-span-1">
                       <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
                         <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600 }}>
                           <div className="w-1 h-6 bg-custom-100 rounded-full"></div>
                           {activeSection === 'trending' ? 'Trending Now' : 'Latest'}
                         </h3>
                         <div className="space-y-4">
                           {filteredPosts.slice(1, Math.min(8, filteredPosts.length)).map((post, index) => (
                             <article key={post.id || index} className="group cursor-pointer">
                               <Link to={`/blog/${post.slug}`} className="block">
                                 <div className="hover:bg-white p-4 rounded-xl transition-all duration-300 hover:shadow-sm border-l-2 border-transparent group-hover:border-[#ab3d22] group-hover:pl-6">
                                   <div className="flex items-center gap-2 text-xs text-gray-500 mb-2">
                                     <span>{formatDate(post.date)}</span>
                                   </div>
                                   <h4 className="text-lg font-semibold text-gray-900 leading-tight group-hover:text-[#ab3d22] transition-colors duration-300 mb-2" 
                                       style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600 }}>
                                     {post.title}
                                   </h4>
                                   <p className="text-sm text-gray-600 leading-relaxed line-clamp-2">
                                     {post.excerpt}
                                   </p>
                                   <div className="flex items-center gap-2 mt-3">
                                     <div className="w-6 h-6 bg-[#ab3d22]/10 rounded-full flex items-center justify-center">
                                       <span className="text-[#ab3d22] font-semibold text-xs">R</span>
                                     </div>
                                     <span className="text-xs text-gray-500">{post.readTime}</span>
                                   </div>
                                 </div>
                               </Link>
                             </article>
                           ))}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               )}

               {/* Regular Grid for other sections */}
               <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
               {filteredPosts.map((post, index) => {
                   // Skip the first post if we're showing the featured layout
                   const shouldSkip = (activeSection === 'trending' || activeSection === 'new') && index === 0;
                   if (shouldSkip) return null;

                 return (
                     <article key={post.id || index} className="group cursor-pointer">
                     <Link to={`/blog/${post.slug}`} className="block h-full">
                         <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-full flex flex-col">
                         <div className="aspect-[4/3] bg-gray-100 overflow-hidden relative">
                           <img
                             src={post.image}
                             alt={`${post.category} guide: ${post.title}`}
                             className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                             onError={(e) => {
                               e.target.src = "data:image/svg+xml,%3Csvg width='400' height='300' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f3f4f6'/%3E%3Ctext x='50%25' y='50%25' font-size='18' fill='%236b7280' text-anchor='middle' dy='.3em'%3ERadiance%3C/text%3E%3C/svg%3E";
                             }}
                           />
                         </div>
                         <div className="p-6 flex-1 flex flex-col">
                             <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                               <span>{formatDate(post.date)}</span>
                               <span>•</span>
                               <span>{post.readTime}</span>
                             </div>
                             <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight line-clamp-2 group-hover:text-[#ab3d22] transition-colors duration-300" 
                                 style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600 }}>
                               {post.title}
                           </h3>
                           <p className="text-gray-600 mb-4 leading-relaxed line-clamp-2 flex-1">
                             {post.excerpt}
                           </p>
                           <div className="flex items-center gap-2 mt-auto">
                             <div className="w-8 h-8 bg-[#ab3d22]/10 rounded-full flex items-center justify-center">
                               <span className="text-[#ab3d22] font-semibold text-xs">R</span>
                             </div>
                             <span className="text-sm font-medium text-gray-700">{post.author}</span>
                           </div>
                         </div>
                       </div>
                     </Link>
                   </article>
                 );
               })}
             </div>
             </>
           )}

          {filteredPosts.length === 0 && !loading && (
            <div className="text-center py-20">
              <div className="max-w-md mx-auto">
                <svg className="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
                <h3 className="text-lg font-medium text-gray-900 mb-2">No results found</h3>
                <p className="text-gray-500">
                  {searchQuery ? (
                    <>Try searching for "retinol", "skincare routine", or "anti-aging"</>
                  ) : (
                    <>No posts available in this section yet.</>
                  )}
                </p>
              </div>
            </div>
          )}

          {/* Show More Button */}
          {filteredPosts.length > 0 && (
            <div className="text-center mt-16">
              <button className="px-8 py-4 bg-white text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow-md border border-gray-200">
                Load More Articles
              </button>
            </div>
          )}
        </Container>
      </div>

      {/* Footer */}
      <footer className="bg-black">
        <Container className="py-12 sm:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            {/* LEFT HALF: Brand + Newsletter */}
            <div className="lg:pr-8">
              <Link 
                to="/" 
                className="text-2xl sm:text-3xl font-bold lowercase mb-6 inline-block hover:opacity-80 transition-opacity"
                style={{ 
                  fontFamily: 'Poppins, sans-serif', 
                  fontWeight: 700,
                  color: '#ffffff'
                }}
              >
                <span style={{ color: '#ffffff' }}>radiance</span><span style={{ color: '#ab3d22' }}>.</span>
              </Link>
              
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Your shortcut to smarter self-care.
              </h3>
              <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
                Honest beauty and wellness guidance, curated picks, and clear reasons why they're worth considering.
              </p>
              
              <a 
                href="http://eepurl.com/jpTPXQ"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#ab3d22] hover:bg-[#8a2f1a] text-white font-semibold rounded-lg transition-colors"
              >
                Subscribe
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
              </a>
              
              <p className="text-gray-500 text-sm mt-4">
                No noise. Just clarity.
              </p>
            </div>

            {/* RIGHT HALF: Links */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
              {/* Explore */}
              <div>
                <div className="font-semibold text-white mb-4">Explore</div>
                <ul className="space-y-2.5 text-gray-400">
                  {categories && categories.length > 0 ? (
                    categories.slice(0, 6).map(category => (
                      <li key={category._id}>
                        <Link to={`/category/${category.slug}`} className="hover:text-white transition-colors">
                          {category.name}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <>
                      <li><Link to="/category/skincare" className="hover:text-white transition-colors">Skincare</Link></li>
                      <li><Link to="/category/hair" className="hover:text-white transition-colors">Hair</Link></li>
                      <li><Link to="/category/makeup" className="hover:text-white transition-colors">Makeup</Link></li>
                      <li><Link to="/category/body" className="hover:text-white transition-colors">Body</Link></li>
                      <li><Link to="/category/wellness" className="hover:text-white transition-colors">Wellness</Link></li>
                      <li><Link to="/category/health" className="hover:text-white transition-colors">Health</Link></li>
                    </>
                  )}
                  <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                </ul>
              </div>

              {/* Company */}
              <div>
                <div className="font-semibold text-white mb-4">Company</div>
                <ul className="space-y-2.5 text-gray-400">
                  <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
                  <li><Link to="/editorial-standards" className="hover:text-white transition-colors">Editorial Standards</Link></li>
                  <li><Link to="/affiliate-disclosure" className="hover:text-white transition-colors">Affiliate Disclosure</Link></li>
                  <li><Link to="/advertise" className="hover:text-white transition-colors">Advertise</Link></li>
                  <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
                  <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
                </ul>
              </div>

              {/* Connect */}
              <div>
                <div className="font-semibold text-white mb-4">Connect</div>
                <ul className="space-y-2.5 text-gray-400">
                  <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Bottom row */}
          <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
            <p>&copy; 2025 Radiance. All rights reserved.</p>
          </div>
        </Container>
      </footer>
    </div>
  );
}

export default BlogIndexPage;